var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('model',{attrs:{"model_name":"user","model_prop":_vm.user,"show_btn_delete":false}}),(_vm.has_extra_config)?_c('div',_vm._l((_vm.extra_config),function(config_model_name){return _c('model',{attrs:{"model_name":config_model_name,"show_btn_delete":false}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }